var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      domProps: { innerHTML: _vm._s(_vm.$t("connections_description")) },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.connections, function (connection, idx) {
        return _c("div", { key: idx, staticClass: "col-md-12" }, [
          !_vm.isMinTransferTime(idx)
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _c("p", [
                  _vm._v(
                    "Planując podróż kilkoma pociągami, załóż na przesiadkę przynajmniej 30 minut, co umożliwi personelowi kolejowemu na danym dworcu zapewnienie pomocy w jego obrębie, w tym podczas przejścia pomiędzy peronami."
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("fieldset", { staticClass: "well" }, [
            _c("legend", [
              connection.station_from
                ? _c("span", [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Połączenie"),
                    ]),
                    _vm._v(
                      "\n            " +
                        _vm._s(idx + 1) +
                        ". " +
                        _vm._s(connection.station_from) +
                        " - " +
                        _vm._s(connection.station_to) +
                        "\n          "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !connection.station_from
                ? _c("span", [_vm._v("Odcinek " + _vm._s(idx + 1))])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0, true),
              _vm._v(" "),
              idx > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger pull-right",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.removeConnection(idx)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "glyphicon glyphicon-remove" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(
                          "Usuń połączenie " +
                            _vm._s(connection.station_from) +
                            " - " +
                            _vm._s(connection.station_to)
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        label: "Stacja początkowa",
                        aria: "Pole jest wymagane",
                        new_id: "station_from" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].station_from"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].station_from"
                        ),
                      },
                    },
                    [
                      _c("ic-station-typeahead", {
                        attrs: {
                          id: "station_from" + idx,
                          valueField: "n",
                          v: _vm.v.form.connections.$each[idx].station_from,
                          noMeta: 1,
                          icStation: -1,
                        },
                        model: {
                          value: connection.station_from,
                          callback: function ($$v) {
                            _vm.$set(connection, "station_from", $$v)
                          },
                          expression: "connection.station_from",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-6 form-padding-left" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "W formacie RRRR-MM-DD. Pole jest wymagane",
                        label: "Data wyjazdu",
                        new_id: "departure_date" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].departure_date"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].departure_date"
                        ),
                      },
                    },
                    [
                      _c("ic-date-picker", {
                        attrs: {
                          id: "departure_date" + idx,
                          v: _vm.v.form.connections.$each[idx].departure_date,
                          endDate: _vm.maxDate,
                        },
                        model: {
                          value: connection.departure_date,
                          callback: function ($$v) {
                            _vm.$set(connection, "departure_date", $$v)
                          },
                          expression: "connection.departure_date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-6 form-padding-left" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "W formacie GG:MM. Pole jest wymagane",
                        label: "Godzina wyjazdu",
                        new_id: "departure_time" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].departure_time"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].departure_time"
                        ),
                      },
                    },
                    [
                      _c("ic-time-picker", {
                        attrs: {
                          id: "departure_time" + idx,
                          v: _vm.v.form.connections.$each[idx].departure_time,
                        },
                        model: {
                          value: connection.departure_time,
                          callback: function ($$v) {
                            _vm.$set(connection, "departure_time", $$v)
                          },
                          expression: "connection.departure_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "Pole jest wymagane",
                        label: "Stacja końcowa",
                        new_id: "station_to" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].station_to"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].station_to"
                        ),
                      },
                    },
                    [
                      _c("ic-station-typeahead", {
                        attrs: {
                          id: "station_to" + idx,
                          valueField: "n",
                          v: _vm.v.form.connections.$each[idx].station_to,
                          noMeta: 1,
                          icStation: -1,
                        },
                        model: {
                          value: connection.station_to,
                          callback: function ($$v) {
                            _vm.$set(connection, "station_to", $$v)
                          },
                          expression: "connection.station_to",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-6 form-padding-left" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "W formacie RRRR-MM-DD. Pole jest wymagane",
                        label: "Data przyjazdu",
                        new_id: "arrival_date" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].arrival_date"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].arrival_date"
                        ),
                      },
                    },
                    [
                      _c("ic-date-picker", {
                        attrs: {
                          id: "arrival_date" + idx,
                          v: _vm.v.form.connections.$each[idx].arrival_date,
                          endDate: _vm.maxDate,
                        },
                        model: {
                          value: connection.arrival_date,
                          callback: function ($$v) {
                            _vm.$set(connection, "arrival_date", $$v)
                          },
                          expression: "connection.arrival_date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-6 form-padding-left" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "W formacie GG:MM. Pole jest wymagane",
                        label: "Godzina przyjazdu",
                        new_id: "arrival_time" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].arrival_time"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].arrival_time"
                        ),
                      },
                    },
                    [
                      _c("ic-time-picker", {
                        attrs: {
                          id: "arrival_time" + idx,
                          v: _vm.v.form.connections.$each[idx].arrival_time,
                        },
                        model: {
                          value: connection.arrival_time,
                          callback: function ($$v) {
                            _vm.$set(connection, "arrival_time", $$v)
                          },
                          expression: "connection.arrival_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "ic-form-row",
                    {
                      attrs: {
                        aria: "Pole jest wymagane",
                        label: "Przewoźnik",
                        new_id: "carrier" + idx,
                        error: _vm.hasError(
                          "form.connections[" + idx + "].carrier"
                        ),
                        required: _vm.isRequired(
                          "form.connections[" + idx + "].carrier"
                        ),
                      },
                    },
                    [
                      _c("ic-select-system", {
                        attrs: {
                          id: "carrier" + idx,
                          values: _vm.carrierTypes,
                          v: _vm.v.form.connections.$each[idx].carrier,
                          placeholder:
                            "... (wybierz jedną z " +
                            _vm.carrierTypes.length +
                            " opcji)",
                        },
                        model: {
                          value: connection.carrier,
                          callback: function ($$v) {
                            _vm.$set(connection, "carrier", $$v)
                          },
                          expression: "connection.carrier",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-4 col-xs-4 form-padding-left" },
                    [
                      _c(
                        "ic-form-row",
                        {
                          attrs: {
                            aria: "Pole jest wymagane",
                            label: "Numer pociągu",
                            new_id: "train_no" + idx,
                            error: _vm.hasError(
                              "form.connections[" + idx + "].train_no"
                            ),
                            required: _vm.isRequired(
                              "form.connections[" + idx + "].train_no"
                            ),
                          },
                        },
                        [
                          _c("ic-input", {
                            attrs: {
                              id: "train_no" + idx,
                              v: _vm.v.form.connections.$each[idx].train_no,
                            },
                            model: {
                              value: connection.train_no,
                              callback: function ($$v) {
                                _vm.$set(connection, "train_no", $$v)
                              },
                              expression: "connection.train_no",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-4 col-xs-4 form-padding-left" },
                    [
                      _c(
                        "ic-form-row",
                        {
                          attrs: {
                            label: "Numer wagonu",
                            new_id: "car_no" + idx,
                            error: _vm.hasError(
                              "form.connections[" + idx + "].car_no"
                            ),
                            required: _vm.isRequired(
                              "form.connections[" + idx + "].car_no"
                            ),
                          },
                        },
                        [
                          _c("ic-input", {
                            attrs: {
                              id: "car_no" + idx,
                              v: _vm.v.form.connections.$each[idx].car_no,
                              type: "number",
                            },
                            model: {
                              value: connection.car_no,
                              callback: function ($$v) {
                                _vm.$set(connection, "car_no", $$v)
                              },
                              expression: "connection.car_no",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-4 col-xs-4 form-padding-left" },
                    [
                      _c(
                        "ic-form-row",
                        {
                          attrs: {
                            label: "Numer miejsca",
                            new_id: "seat_no" + idx,
                            error: _vm.hasError(
                              "form.connections[" + idx + "].seat_no"
                            ),
                            required: _vm.isRequired(
                              "form.connections[" + idx + "].seat_no"
                            ),
                          },
                        },
                        [
                          _c("ic-input", {
                            attrs: {
                              id: "seat_no" + idx,
                              v: _vm.v.form.connections.$each[idx].seat_no,
                              type: "number",
                            },
                            model: {
                              value: connection.seat_no,
                              callback: function ($$v) {
                                _vm.$set(connection, "seat_no", $$v)
                              },
                              expression: "connection.seat_no",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    this.connections.length < 6
      ? _c(
          "button",
          {
            staticClass: "btn btn-toggle btn-block",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.addConnection.apply(null, arguments)
              },
            },
          },
          [
            _vm._v(
              "Dodaj odcinek przejazdu innym pociągiem lub podróż powrotną."
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticStyle: { "font-size": "0.7em" } }, [
      _vm._v("\n            (Jeżeli\n            "),
      _c("strong", [_vm._v("podróż jest z przesiadką")]),
      _vm._v(" należy uzupełnić każdy odcinek oddzielnie)\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }